// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"91a218223c5efe08fdb1","532":"6c785b867c7d0f558060","678":"7d8e91d8fd0e59dee276","883":"a73708baf8a54c2616c9"}[chunkId] + ".js";
};